
import { 
  BadgeDollarSign, 
  BadgeEuro, 
  BadgePoundSterling, 
  BadgeJapaneseYen,
  BadgeIndianRupee,
  SwissFranc,
  Currency
} from 'lucide-react';
import { useCurrency } from '@/contexts/CurrencyContext';

interface CurrencyIconProps {
  className?: string;
  currency?: string; // Allow override for specific currency
}

export function CurrencyIcon({ className = "h-4 w-4", currency }: CurrencyIconProps) {
  const { currency: userCurrency } = useCurrency();
  const activeCurrency = currency || userCurrency;

  const getCurrencyIcon = (curr: string) => {
    switch (curr) {
      case 'USD':
      case 'CAD':
      case 'AUD':
        return BadgeDollarSign;
      case 'EUR':
        return BadgeEuro;
      case 'GBP':
        return BadgePoundSterling;
      case 'JPY':
      case 'CNY':
        return BadgeJapaneseYen;
      case 'INR':
        return BadgeIndianRupee;
      case 'CHF':
        return SwissFranc;
      default:
        return Currency;
    }
  };

  const IconComponent = getCurrencyIcon(activeCurrency);
  
  return <IconComponent className={className} />;
}
